
import React, { Fragment, useEffect, useState } from "react";
import { post_API_CREATE_TICKET, gAPI_FORMS_CATEGORY } from "../../constants/api";
import loader from "../../assets/images/plugin_loader.gif";
import IntlMessage from "../helpers/IntlMessages";
const Ticket = ({ gid, pid, propertyDetails, lang, handleManage}) => {
    const [isMessage, setMessage] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [formCategories, setFormsCategories] = useState([]);
    const [errorMsg, setErrorMsg] = useState([]);
    const [ticketData, setTicketData] = useState({
        category: '',
        title: '',
        notes: '',
        status: 'Pending',
        assign: ''
    });

    useEffect(() => {
        fetch(
            gAPI_FORMS_CATEGORY +
            `?gid=` + gid +
            "&pid=" + pid + "&lang=" +
            lang,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => response.json())
            .then((json) => {
                setFormsCategories(json);
            }).catch(err => { });
    }, [pid]);
    const handleChange = (e) => {
        setErrorMsg('');
        setTicketData({ ...ticketData, [e.target.name]: e.target.value });
    }

    const handleOpen = (url) => {

    }

    const handleCategory = (e) => {
        setErrorMsg('');
        if (ticketData?.title === '' || ticketData?.category === ticketData?.title)
            setTicketData({ ...ticketData, title: e.target.value, category: e.target.value });
        else setTicketData({ ...ticketData, category: e.target.value });
    }

    console.log(propertyDetails);
    const handleClickreload = () => {
        setTicketData({
            category: '',
            title: '',
            notes: '',
            status: 'Open',
            assign: ''
        });
        setMessage(false);
    }

    const handleSubmit = () => {
        if (ticketData?.title === '' || ticketData?.category === '') {
            setErrorMsg('Please enter all required details.');
        } else {
            setIsLoader(true);
            fetch(post_API_CREATE_TICKET,
                {
                    method: "Post",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(
                        {
                            "notes": ticketData?.notes,
                            "tags": [ticketData?.category ? ticketData?.category : "Query"],
                            "creator": "OutlookPlugin",
                            "Source": "OutlookPlugin",
                            "conversationId": "",
                            "channel":"Email",
                            "propertyId": pid,
                            "groupId": gid,
                            "status": "Pending",
                            "type": null,
                            "title": "Query",
                            "assignTo": ticketData?.assign,
                            "statusNotes": [
                                { "assignEmail": ticketData?.assign, "text": `Assigned to ${ticketData?.assign}`, "createdBy": "Outlook" },
                            ]
                        }
                    ),
                }).then(res => res.json()).then((result) => {
                    setIsLoader(false);
                    setMessage(true);
                });
        }
    }
    return (
        <Fragment>
            <div className="card-body-mobile" >
                {isLoader ? (
                    <div style={{
                        width: "100%",
                        position: "absolute",
                        bottom: "0",
                        zIndex: "1000",
                        opacity: "1",
                        height: "100%",
                        top: "0rem"
                    }}>
                        <div style={{ position: "relative", top: "10rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className="img-loader" role="status">
                                <img src={loader} style={{ width: "80px", height: "80px" }} alt="loader" />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div >
                           <div className="ml-3" style={{position:'relative', display: 'flex'}}>
                         <a href="#" onClick={() => handleManage('page', 'main')}  style={{ float: 'left' }}>
                                <span className="color-dark-dark">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                                    </svg> </span>
                            </a>
                           </div>
                    <div className="card-mobile" style={
                        { borderRadius: "1px" }
                    }>
                  
                        {isMessage === true ? (
                            <div className="card-form-style">
                                <div
                                    className="content-form"
                                    style={{
                                        padding: "15%",
                                        textAlign: "center",
                                        fontSize: "20px",
                                        fontWeight: "600",
                                        lineBreak: "auto",
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                >

                            <IntlMessage id="ticket.submit_form" />
                                    <div
                                        style={{ cursor: "pointer", marginTop: "10px" }}
                                        onClick={() => handleClickreload()}
                                    >
                                        <svg
                                            style={{ transform: "scale(2,-2) rotate(70deg)" }}
                                            width="10pt"
                                            height="10pt"
                                            viewBox="0 0 200.000000 200.000000"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <g
                                                transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
                                                fill="#000000"
                                                stroke="none"
                                            >
                                                <path d="M847 1889 c-98 -13 -244 -64 -329 -114 -327 -193 -497 -559 -433 -930 63 -359 329 -637 691 -721 112 -26 301 -24 409 5 169 45 325 138 441 265 121 131 158 214 104 231 -27 9 -35 2 -77 -63 -113 -177 -306 -310 -519 -357 -105 -24 -300 -17 -399 15 -275 87 -484 303 -557 578 -29 112 -29 288 1 401 73 279 279 494 556 581 106 34 301 39 416 12 165 -40 291 -114 411 -241 66 -70 158 -214 145 -227 -2 -3 -67 13 -143 35 -118 33 -142 37 -159 26 -23 -14 -29 -34 -16 -53 13 -22 392 -124 416 -113 16 7 31 49 74 206 56 203 57 225 17 233 -30 6 -43 -17 -76 -136 -18 -64 -35 -121 -37 -125 -3 -5 -19 15 -36 45 -152 268 -426 435 -740 452 -51 2 -123 0 -160 -5z" />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <Fragment>
                                    <div className="cardbody-property">
                                        <div className="cardbody-propertyimage">
                                            <img src={propertyDetails?.images} style={{ width: "100px" }} alt="Cloudy Sky" />
                                        </div>
                                        <span>
                                        </span>
                                    </div>
                                    <div className="cardbody-title"><IntlMessage id="ticket.ticket" /></div>
                                </Fragment>
                                <div className="cardbody-subtitle">
                                   <IntlMessage id="ticket.details" />
                                    <hr />
                                </div>
                                <div className="card-form-style">
                                    <div className="content m-0">
                                        <div
                                            className={`demo-animation needs-validation m-0`}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <div className="form-custom form-label mb-3">
                                                <select placeholder="Full Name *" name="category" type="text" onChange={handleCategory}
                                                    className="form-control rounded-xs  form-control" value={ticketData?.category}>
                                                    <option value={""}><IntlMessage id="ticket.select_category" /></option>
                                                    {formCategories.length > 0 && formCategories.map(m => <option value={m.value}>{m.label}</option>)}
                                                </select>
                                                <label className="color-theme form-label-active"><IntlMessage id="ticket.category" /> *

                                                </label>
                                            </div>
                                            <div className="form-custom form-label mb-3">
                                                <input placeholder="Title *" name="title" type="text" onChange={handleChange}
                                                    className="form-control rounded-xs  form-control" value={ticketData?.title} />
                                                <label className="color-theme form-label-active"><IntlMessage id="ticket.title" /> *

                                                </label>
                                            </div>
                                            <div className="form-custom form-label mb-3">
                                                <textarea placeholder="Notes" name="notes" type="text" onChange={handleChange}
                                                    className="form-control rounded-xs  form-control" value={ticketData?.notes} />
                                                <label className="color-theme form-label-active"><IntlMessage id="ticket.notes" />

                                                </label>
                                            </div>
                                            <div className="form-custom form-label mb-3" >
                                                <div className="form-custom form-label mb-3">
                                                    <select placeholder="Full Name *" name="status" onChange={handleChange}
                                                        className="form-control rounded-xs  form-control" value={ticketData?.status}>
                                                        <option value={"Open"}>Open</option>
                                                        <option value={"Pending"}>Assigned</option>
                                                        <option value={"Solved"}>Solved</option>
                                                        <option value={"Escalated"}>Escalated</option>
                                                    </select>
                                                    <label className="color-theme form-label-active"><IntlMessage id="ticket.status" /> *

                                                    </label>
                                                </div>
                                            </div>
                                            <div className="form-custom form-label mb-3" >
                                                <div className="form-custom form-label mb-3">
                                                    <input placeholder="Assign To" name="assign" type="text" onChange={handleChange}
                                                        className="form-control rounded-xs  form-control" value={ticketData?.assign} />
                                                    <label className="color-theme form-label-active"><IntlMessage id="ticket.assigned_to" /> 

                                                    </label>
                                                </div>
                                            </div>
                                            {errorMsg !== '' &&
                                                    <div className="invalid-inputs mb-2" style={{color:'red'}}>
                                                        {errorMsg}
                                                    </div>
                                            }

                                        
                                            <div className="col-12 text-center">
                                                <button type="submit" onClick={(e) => handleSubmit(e)} className="btn-full btn button-myma-primary button-width-55 mb-6" >
                                                   <IntlMessage id="ticket.submit_form" />
                                                </button>
                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )}
                    </div>
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default Ticket;